import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState, Flex } from 'onefaceui-react-components';

import { getResourceTo } from 'react/utils/utils';
import { ActivityCenterPhotoItem } from './ActivityCenterPhotoItem';

function ActivityCenterContent({ items }) {
  const mapperItem = {
    photo: ActivityCenterPhotoItem
  };

  return (
    <Flex
      dataTestId="activityCenter-content"
      flexDirection="column"
      className="activityCenterContent"
      gap={6}
    >
      {items.length > 0 && items.map((item) => {
        const Comp = mapperItem[item.type || 'photo'];

        return <Comp key={item.id} {...item} />;
      })}

      {items.length === 0 && (
        <EmptyState message={getResourceTo('activityCenter.emptyDescription')} />
      )}
    </Flex>
  );
}

ActivityCenterContent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};

ActivityCenterContent.defaultProps = {
  items: []
};

export { ActivityCenterContent };
